import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "487070cf-43d6-473c-8d18-49679fc67fb7",
  publicId: "24",
  name: "Image sources ",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, principle05, principle06, task01],
};

export default lesson;
